import styled from '@emotion/styled';
import CloudOff from '@material-ui/icons/CloudOff';
import { spacing } from '$variables/theme';
import COLORS from '$variables/colors';

export const ModalContent = styled.div`
  padding: 0 ${spacing.small} ${spacing.small};
  text-align: center;
`;

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
`;

export const ErrorIcon = styled(CloudOff)`
  font-size: 32px;
  margin-right: ${spacing.medium};
  color: ${COLORS.errorRed};
`;
